import { Space, Spinner } from "@masterteam/mt-design-react";
import sortBy from "lodash/sortBy";
import React, { useEffect, useState } from "react";

import Header from "./Header";
import ObjectivesCards from "./ObjectivesCards";
import Statuses from "./Statuses";
import SummaryCharts from "./SummaryCharts";
import ThemesPillars from "./ThemesPillars";
import Values from "./Values";
import VisionMission from "./VisionMission";

import { addToast } from "../../helpers";
import api from "../../providers/api";

import "./style.scss";

function StrategyMap({ match }) {
  const { id } = match?.params;
  const [data, setData] = useState([]);
  const [thresholds, setThresholds] = useState([]);
  const [projectStatuses, setProjectStatuses] = useState([]);
  const [systemStatuses, setSystemStatuses] = useState([]);
  const [orgStructure, setOrgStructure] = useState([]);
  const [initiativeStatus, setInitiativeStatus] = useState([])
  const [loading, setLoading] = useState(true);
  const [statusLoading, setStatusLoading] = useState(true);
  const [selectedThemePillar, setSelectedThemePillar] = useState(null);
  const [selectedSectors, setSelectedSectors] = useState([]);
  const [levelOneSelected, setLevelOneSelected] = useState(true);
  const [levelTwoSelected, setLevelTwoSelected] = useState(false);

  const getStatuses = async () => {
    setStatusLoading(true);
    try {
      const [
        thresholdsRes,
        projectStatusesRes,
        systemStatusesRes,
        orgStructureRes,
        initiativeStatusRes
      ] = await Promise.all([
        api.handshake.getKPIStatuses(),
        api.handshake.getProjectStatuses(),
        api.handshake.getSystemStatuses(),
        api.orgStructure.getAllTree(),
        api.initiatives.initiativeStatuses()
      ]);

      setThresholds(
        thresholdsRes?.Data ? sortBy(thresholdsRes?.Data, "Order") : []
      );
      setProjectStatuses(
        projectStatusesRes?.Data
          ? sortBy(projectStatusesRes?.Data, "Order")
          : []
      );
      setSystemStatuses(
        systemStatusesRes?.Data ? sortBy(systemStatusesRes?.Data, "Order") : []
      );
      setOrgStructure(orgStructureRes?.Data || []);
      setInitiativeStatus(initiativeStatusRes?.Data || [])
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error"
      });
    } finally {
      setStatusLoading(false);
    }
  };

  const getStrategyData = async () => {
    setLoading(true);
    try {
      const res = await api.strategyMap.getStrategyByID(id);

      setData(res.Data);
      setSelectedThemePillar(null);
      setLevelOneSelected(true);
      setLevelTwoSelected(false);
      setSelectedSectors([]);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error"
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStrategyData();
  }, [id]);

  useEffect(() => {
    if (id) getStatuses();
  }, []);

  if (statusLoading) {
    return (
      <div className="loader-container">
        <Spinner size="large" />
      </div>
    );
  }
  return (
    <Space direction="vertical" size="large" className="strategy-map-container">
      {loading ? (
        <div className="loader-container">
          <Spinner size="large" />
        </div>
      ) : (
        <Space direction="vertical" size="large">
          <Header data={data} getStrategyData={getStrategyData} />

          <Space
            direction="vertical"
            size="large"
            className="strategy-map-container__body"
          >
            {data?.ShowVisionMission && <VisionMission strategy={data} />}

            {data?.ShowSummary && (
              <SummaryCharts
                strategy={data}
                thresholds={thresholds}
                projectStatuses={data?.StrategyType === 1 ? projectStatuses:initiativeStatus}
                systemStatuses={systemStatuses}
                levels={data?.Perspectives?.[0]?.Objectives?.map(item => ({id: item?.ID,Levels: item?.Levels}))}
              />
            )}

            <ThemesPillars
              strategy={data}
              selectedThemePillar={selectedThemePillar}
              setSelectedThemePillar={setSelectedThemePillar}
            />

            <ObjectivesCards
              strategy={data}
              statuses={thresholds}
              projectStatuses={projectStatuses}
              orgStructure={orgStructure}
              selectedSectors={selectedSectors}
              levelOneSelected={levelOneSelected}
              levelTwoSelected={levelTwoSelected}
              setSelectedSectors={setSelectedSectors}
              setLevelOneSelected={setLevelOneSelected}
              setLevelTwoSelected={setLevelTwoSelected}
              selectedThemePillar={selectedThemePillar}
              initiativeStatus={initiativeStatus}
            />

            {data?.ShowValues && <Values strategy={data} />}
          </Space>

          <Statuses thresholds={thresholds} />
        </Space>
      )}
    </Space>
  );
}

export default StrategyMap;
